import { OfferingSearchRequestQuery, OfferingSearchResponse } from '@lio/api-types';
// Direct imports avoid circular dependency with barrel re-export.
import { offeringsQueryKey } from './keys';
import { getOfferingsQuery } from './offerings.helpers';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchOfferings = (params: OfferingSearchRequestQuery, enabled: boolean) => {
  const client = useClient();
  const query = getOfferingsQuery({ pageLimit: 100, ...params });
  const result = useQuery({
    queryKey: offeringsQueryKey.searchWithParams(params),
    queryFn: () => client.get(`offering?${query}`).json<OfferingSearchResponse>(),
    refetchOnWindowFocus: false,
    enabled,
  });

  return { ...result, offerings: result.data };
};
